import {createSelector} from 'reselect';

const getActivityState = state => state.activities;

export const getActivityBlocks = createSelector(
  getActivityState,
  state => state.blocks
);
export const isFetchingActivities = createSelector(
  getActivityState,
  state => state.isFetching
);

export const doesIssueHavePreviousActivities = createSelector(
  getActivityState,
  state => state.blocks.length < state.total
);

export const getCurrentActivitiesOffset = createSelector(
  getActivityState,
  state => state.offset
);

export const getActivityDummyBlock = createSelector(
  getActivityState,
  state => state.dummyBlock
);

export const activityServiceErrored = createSelector(
  getActivityState,
  state => state.hasError
);
